var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exam_details"},[_c('Details',{attrs:{"crumbsConfig":_vm.crumbsConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }